import { createParser, parseAsString } from 'nuqs/server'
import * as v from 'valibot'

const coordinateSchema = v.pipe(v.unknown(), v.transform(Number), v.number(), v.finite())

const coordinatesSchema = v.tuple([coordinateSchema, coordinateSchema])

const locationCoordinatesParser = createParser<[number, number]>({
  serialize,
  parse,
}).withDefault([0, 0])

export const locationParser = {
  location: parseAsString.withDefault(''),
  locationCoordinates: locationCoordinatesParser,
  locationType: parseAsString.withDefault(''),
}

function serialize(coordinates: [number, number] | null | undefined): string {
  const result = v.safeParse(coordinatesSchema, coordinates)
  if (!result.success) return ''

  const [longitude, latitude] = result.output
  return `${longitude},${latitude}`
}

function parse(
  coordinateString: string | (string | null)[] | null | undefined
): [number, number] | null {
  const isValidString = coordinateString && typeof coordinateString === 'string'
  if (!isValidString) return null

  const [longitude, latitude] = coordinateString.split(',')

  const result = v.safeParse(coordinatesSchema, [longitude, latitude])
  return result.success ? result.output : null
}
